import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";

import { Http } from "../../../../helpers/Http";
import { useLocation, useOutletContext } from "react-router-dom";

import { es } from "date-fns/locale"; 
import { parse, format } from "date-fns";

import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("es-sunday", {
  ...es,
  options: {
    ...es.options,
    weekStartsOn: 0, // 0 = Domingo, 1 = Lunes
  },
});

const MantEmployee = ({mant, idEdit, createData, updateData, closeSection, areas, cargos, tipos, tiposDocumento, idRef,
                          setIdRef, endPointShow, setEndPointUpdate, init, showEdit, showCreate }) => {
    const location = useLocation();
    const { showSpinnerLoader } = useOutletContext();

    const { register, handleSubmit, resetField, reset, setValue, formState: { errors } } = useForm({mode: "onChange"});
    const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    const [fechaIngreso, setFechaIngreso] = useState(CONFIGURACIONES.INIT.STRING);
    const [fechaNacimiento, setFechaNacimiento] = useState(CONFIGURACIONES.INIT.STRING);
    const [patronDocumento, setPatronDocumento] = useState(CONFIGURACIONES.INIT.STRING);
    const [fechaActual, setFechaActual] = useState(new Date());
    const [areaEmpleadoRefId, setAreaEmpleadoRefId] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [cargoEmpleadoRefId, setCargoEmpleadoRefId] = useState(CONFIGURACIONES.INIT.NUMBER);

    useEffect(() => {
        reset();
        showSpinnerLoader();

        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSeg', lastSegment);

        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            init();
            setIdRef((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            showData((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            setTitle((lastSegment === 'new')? `Creando ${mant}`:`Editando ${mant}`);
        }

    }, [location.pathname]);

    useEffect(() => {
        setValue("cargoEmpleadoId", cargoEmpleadoRefId); // Limpia el select de cargo
    }, [cargoEmpleadoRefId, setValue]);

    const onSubmit1 = (form) => {
        // console.log('form', form);
        if (idRef === CONFIGURACIONES.INIT.ID_EDIT) {
            createData(form);
        } else {
            updateData(form);
        }
    };

    const showData = async (ref) => {
        console.log('ref', ref);
        
        if (ref !== CONFIGURACIONES.INIT.ID_EDIT) {
            console.log('entras...', endPointShow);
            if (endPointShow === CONFIGURACIONES.INIT.STRING || !showEdit) { closeSection(); }
            
            await Http().get(endPointShow)
            .then(async (rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    // setLinks(rpta.data.links);
                    setEndPointUpdate(rpta.data.links.find(link => link.rel === CONFIGURACIONES.REFS.UPDATE)?.href || null);
                    // let cmpLink = rpta.data.links.find(link => link.rel === CONFIGURACIONES.INIT.HREF_LOGS);
                    // console.log('cmpLink', cmpLink);
                    // await loadLogData(cmpLink?.href);
                    loadForm(rpta.data);
                }
            });
        } else {
            if (!showCreate) { closeSection(); }
        }
    };

    const loadForm = (object) => {
        // changeAreaEmpleado(object.areaEmpleadoId);
        // setCargosSelect(cargos.filter(cargo => cargo.area_empleado_id == object.areaEmpleadoId));
        // console.log('area', object.areaEmpleadoId);
        // console.log('cargos', cargos);
        // console.log('cargosSelect', cargosSelect);
        setAreaEmpleadoRefId(object.areaEmpleadoId);
        setCargoEmpleadoRefId(object.cargoEmpleadoId);
        setValue('tipoDocumentoRefId', `${object.tipoDocumentoId}@@${object.patronValidacionDocumento}`);
        setValue('tipoDocumentoId', object.tipoDocumentoId);
        setValue('numeroDocumento', object.numeroDocumento);
        setValue('nombres', object.nombres);
        setValue('apellidoPaterno', object.apellidoPaterno);
        setValue('apellidoMaterno', object.apellidoMaterno);
        setValue('celular', object.celular);
        setValue('correoElectronico', object.correoElectronico);
        setValue('fechaNacimiento', object.fechaNacimiento);
        setValue('genero', object.genero);
        setValue('tipoEmpleadoId', object.tipoEmpleadoId);
        setValue('fechaIngreso', object.fechaIngreso);
        
        // 
        setFechaNacimiento(parse(object.fechaNacimiento, "yyyy-MM-dd", new Date()));
        setFechaIngreso(parse(object.fechaIngreso, "yyyy-MM-dd", new Date()));
        setPatronDocumento(new RegExp(object.patronValidacionDocumento));
       
        setValue('areaEmpleadoId', object.areaEmpleadoId);
        // setValue('cargoEmpleadoId', object.cargoEmpleadoId);
    };

    const cargosSelect = useMemo(() => {
        if (areaEmpleadoRefId == 0) return [];
        
        return cargos.filter(cargo => cargo.area_empleado_id == areaEmpleadoRefId);
        
    }, [cargos, areaEmpleadoRefId]);
    
    // const changeAreaEmpleado = (value) => {
    //     setCargosSelect(cargos.filter(cargo => cargo.area_empleado_id == value));
    // };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold">{title}</h5>
                            <div className="row pb-3 border-bottom">
                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="tipoDocumentoRefId" className="control-label col-form-label">Tipo de Documento <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoDocumentoRefId", {
                                                required: OWASP.REQUIRED,
                                                onChange:(e) => {
                                                    setPatronDocumento(new RegExp(e.target.value.split('@@')[1]));
                                                    setValue("tipoDocumentoId", e.target.value.split('@@')[0]);
                                                    resetField("numeroDocumento");
                                                }
                                            })} className="form-control" id="tipoDocumentoRefId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                tiposDocumento.map((el, index) => (
                                                    <option key={index} value={`${el.id}@@${el.patron_validacion}`}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <input  
                                            {...register("tipoDocumentoId", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="hidden" />
                                        <small className="invalid-feedback"> { errors.tipoDocumentoId && errors.tipoDocumentoId.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="numeroDocumento" className="control-label col-form-label">Documento <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("numeroDocumento", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: patronDocumento,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="numeroDocumento" placeholder="" />
                                        <small className="invalid-feedback"> { errors.numeroDocumento && errors.numeroDocumento.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="apellidoPaterno" className="control-label col-form-label">Apellido Paterno <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("apellidoPaterno", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="apellidoPaterno" placeholder="" />
                                        <small className="invalid-feedback"> { errors.apellidoPaterno && errors.apellidoPaterno.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="apellidoMaterno" className="control-label col-form-label">Apellido Materno <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("apellidoMaterno", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="apellidoMaterno" placeholder="" />
                                        <small className="invalid-feedback"> { errors.apellidoMaterno && errors.apellidoMaterno.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="nombres" className="control-label col-form-label">Nombres <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("nombres", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="nombres" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombres && errors.nombres.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="celular" className="control-label col-form-label">Celular <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("celular", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="tel" className="form-control" id="celular" placeholder="" maxLength={12} />
                                        <small className="invalid-feedback"> { errors.celular && errors.celular.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="correoElectronico" className="control-label col-form-label">Email <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("correoElectronico", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.EMAIL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="email" className="form-control" id="correoElectronico" placeholder="" />
                                        <small className="invalid-feedback"> { errors.correoElectronico && errors.correoElectronico.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="fechaNacimientoDatePicker" className="control-label col-form-label">Fecha de Nacimiento <span className="text-danger">*</span></label>

                                        <DatePicker dateFormat={"dd/MM/yyyy"} 
                                            id="fechaNacimientoDatePicker"
                                            placeholderText="dd / mm / aaaa" 
                                            className="form-control text-center"
                                            locale="es-sunday"
                                            selected={fechaNacimiento}
                                            dayClassName={(date) =>
                                                date.getDay() === 0 || date.getDay() === 6? "weekend-day" : undefined
                                            }
                                            onChange={(date) => {
                                                setFechaNacimiento(date);
                                                setValue("fechaNacimiento",  format(date, "yyyy-MM-dd"), 
                                                { shouldValidate: true });
                                            }}
                                            onChangeRaw={(e) => e.preventDefault()}
                                            showMonthDropdown
                                            showYearDropdown
                                            popperClassName="datepicker-popper"
                                            maxDate={fechaActual}
                                        />
                                        <input 
                                            {...register("fechaNacimiento", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.DATE,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="hidden" />
                                        <small className="invalid-feedback"> { errors.fechaNacimiento && errors.fechaNacimiento.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="genero" className="control-label col-form-label">Género <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("genero", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="genero" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                CONFIGURACIONES.INIT.LIST.GENEROS.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.genero && errors.genero.message }</small>           
                                    </div>
                                </div>
                            </div>

                            <div className="row pt-4">
                                <div className="col-sm-12">
                                    <h5 className="card-title text-muted">Relación Laboral</h5>
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="areaEmpleadoId" className="control-label col-form-label">Área <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("areaEmpleadoId", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    setValue("cargoEmpleadoId", "");
                                                    setAreaEmpleadoRefId(e.target.value);
                                                }
                                            })} className="form-control" id="areaEmpleadoId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                areas.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.areaEmpleadoId && errors.areaEmpleadoId.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="cargoEmpleadoId" className="control-label col-form-label">Cargo <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("cargoEmpleadoId", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="cargoEmpleadoId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                cargosSelect.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.cargoEmpleadoId && errors.cargoEmpleadoId.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipoEmpleadoId" className="control-label col-form-label">Tipo <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoEmpleadoId", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="tipoEmpleadoId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                               
                                            {
                                                tipos.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipoEmpleadoId && errors.tipoEmpleadoId.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="fechaIngresoDatePicker" className="control-label col-form-label">Fecha de Ingreso <span className="text-danger">*</span></label>
                                        <DatePicker dateFormat={"dd/MM/yyyy"} 
                                            id="fechaIngresoDatePicker"
                                            placeholderText="dd / mm / aaaa" 
                                            className="form-control text-center"
                                            locale="es-sunday"
                                            selected={fechaIngreso}
                                            dayClassName={(date) =>
                                                date.getDay() === 0 || date.getDay() === 6? "weekend-day" : undefined
                                            }
                                            onChange={(date) => {
                                                setFechaIngreso(date);
                                                setValue("fechaIngreso",  format(date, "yyyy-MM-dd"), 
                                                { shouldValidate: true });
                                            }}
                                            onChangeRaw={(e) => e.preventDefault()}
                                            showMonthDropdown
                                            showYearDropdown
                                            popperClassName="datepicker-popper"
                                            maxDate={fechaActual}
                                        />
                                        <input 
                                            {...register("fechaIngreso", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.DATE,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="hidden" />
                                        <small className="invalid-feedback"> { errors.fechaIngreso && errors.fechaIngreso.message }</small>           
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                       
                    <div className="action-form mt-1 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantEmployee;